import React, { useState } from "react";
import { css, Global } from "@emotion/core";
import { ThemeProvider } from "emotion-theming";
import Helmet from "react-helmet";
import Header from "@src/components/Header";
import Footer from "@src/components/Footer";
import Modal from "react-modal";
import normalize from "../styles/normalize";
import theme from "../styles/theme";
import { ModalProvider, ModalRoot } from "@src/components/modals/ModalController";
import { TranslationProvider } from "@src/components/translation/TranslationContext";
import { AppDataContextProvider } from "@src/components/AppDataContext";
import "modern-normalize/modern-normalize.css";
import { useLocation } from "@reach/router";
import { generatingFor } from "@src/utils/routes";
import Spacer from "@src/components/Spacer";
import StyledLayoutMain from "@src/layouts/common/StyledLayoutMain";
import { url } from "inspector";

Modal.setAppElement("#___gatsby");

type PageLayoutProps = {
  children: any;
  pageContext: any;
};
const PageLayout: React.FC<PageLayoutProps> = ({ children, pageContext }) => {
  const urlsWithoutBanner = [
    "/remotelearning",
    "/remotelearning_lp",
    "/worksheets",
    "/worksheets-success",
    "/schoolleader",
    "/teacherlp",
    "/teacherlp2",
    "/teacherlp3",
    "/encouragelp",
    "/googleclassroom",
    "/training",
    "/engagelp",
    "/schoolleader2",
    "/student-login-w-parent-help",
    "/homePoints",
    "/homeRewards",
  ];
  const urlsWithoutNav = [
    "/teacherlp",
    "/teacherlp2",
    "/teacherlp3",
    "/encouragelp",
    "/googleclassroom",
    "/schoolleader2",
    "/student-login-w-parent-help",
    "/homePoints",
    "/homeRewards",
  ];
  const urlsWithoutHeader = ["/ecard"];

  const isRemoteLearningPage = (pathname: string) => {
    let result = false;
    urlsWithoutBanner.forEach((url) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      if (pathname.endsWith(url)) result = true;
    });
    return result;
  };

  const isNavHidden = (pathname: string) => {
    let result = false;
    urlsWithoutNav.forEach((url) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      if (pathname.endsWith(url)) result = true;
    });
    return result;
  };

  const isHeaderHidden = (pathname: string) => {
    let result = false;
    urlsWithoutHeader.forEach((url) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      if (pathname.endsWith(url)) result = true;
    });
    return result;
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pathname = location.pathname.endsWith("/") ? location.pathname.slice(0, -1) : location.pathname;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [closureBannerOpen, setclosureBannerOpen] = useState<boolean>(true);
  const closeBanner = () => setclosureBannerOpen(false);
  const showClosureBanner = !isRemoteLearningPage(pathname) && closureBannerOpen;
  const hideNav = isNavHidden(pathname);
  const hideHeader = isHeaderHidden(pathname);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const hideFooter = pathname.endsWith("/student-login-w-parent-help");
  generatingFor.locale = pageContext.localeStrings.currentLocale;

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://static.classdojo.com/fonts/proxima/proximanova-default-stack.css" />
      </Helmet>
      <Global
        styles={css`
          ${normalize};
          #___gatsby,
          #gatsby-focus-wrapper,
          main,
          html,
          body {
            height: 100%;
          }

          /* modal transitions:  */
          .ReactModal__Content {
            opacity: 0;
            transform: translate(0, -50%);
            transition: transform 300ms ease-out;
          }

          .ReactModal__Content--after-open {
            opacity: 1;
            transform: translate(0, 0);
          }

          .ReactModal__Content--before-close {
            opacity: 0;
            transform: translate(0, -50%);
          }
        `}
      />
      <TranslationProvider localeStrings={pageContext.localeStrings}>
        <ThemeProvider theme={theme}>
          <AppDataContextProvider>
            <ModalProvider>
              {/*<Flex flexDirection="column" height="100%" overflowX="hidden">*/}
              <ModalRoot />
              <StyledLayoutMain id="main-page-container">
                {!hideHeader && (
                  <>
                    <Header showClosureBanner={showClosureBanner} closeBannerFunction={closeBanner} hideNav={hideNav} />
                    {showClosureBanner ? <Spacer height="148px" /> : <Spacer height="88px" />}
                  </>
                )}
                {children}
                {!hideFooter && <Footer />}
              </StyledLayoutMain>
              {/*</Flex>*/}
            </ModalProvider>
          </AppDataContextProvider>
        </ThemeProvider>
      </TranslationProvider>
    </>
  );
};

export default PageLayout;
